import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import format from "date-fns/format";
import parseJSON from "date-fns/parseJSON";
import unescape from "lodash/unescape";

import { faSync } from "@fortawesome/free-solid-svg-icons/faSync";

import { Title } from "components/customElements";
import FontAwesomeIcon from "components/FontAwesomeIcon";
import RichContent from "components/RichContent";

import style from "./style.module.scss";

type Props = {
  account: any;
  republishedAt: Date;
  boomerangReason: string;
};

const InsightBoomerang = ({
  account,
  republishedAt,
  boomerangReason,
}: Props) => {
  const firstName = account?.name?.split(" ")?.[0];

  return (
    <div className="mt-[15px]">
      <Title>
        <OverlayTrigger
          overlay={
            <Tooltip>
              {firstName} has resurfaced this previously published Insight
            </Tooltip>
          }
        >
          <span className="!text-[19px] !text-[#f8ca47]">
            <FontAwesomeIcon icon={faSync} className={style.icon} />
          </span>
        </OverlayTrigger>
        <span className="!text-[12px] !text-gray-gray" suppressHydrationWarning>
          {" "}
          Boomeranged on{" "}
          {format(parseJSON(republishedAt), "eee, d MMM yyyy HH:mm")}
        </span>
      </Title>
      <RichContent>{unescape(boomerangReason)}</RichContent>
    </div>
  );
};

export default InsightBoomerang;
